import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import Dashboard from "../../CustomComponents/Property/Dashboard/Dashboard";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import VendorDashboard from "../../CustomComponents/Property/VendorDashboard/VendorDashboard";
import styles from "../../Pages/Agent/AgentDashboard/AgentDashboard.module.scss";

function PropertyOverview({ allPropertiesPage }) {
  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} />
            <VendorDashboard />
        </div>
      </div>
    </>
  );
}

export default PropertyOverview;
